import React from 'react';
import styled from 'styled-components';
import useContentPoliticas from '../hooks/parameter/useContentPoliticas.js';

const DivContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  min-height: 400px;
  max-width: 1200px;

  p {
    // align-selft: center;
    text-align: center;
    // width: 80%;

    img {
      margin-top: 2.5rem;
      width: 100% !important;
    }
  }
`;

export const PagePoliticaCalidad = () => {
  window.scroll(0, 0);
  const { contentPoliticas } = useContentPoliticas();

  let bodyHTML = '';

  contentPoliticas?.length > 0 &&
    contentPoliticas.find((element) => {
      element.texto_titulo === 'Política de calidad' &&
        (bodyHTML = element.texto_contenido);
    });

  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <DivContainer id='contBodyHTML'>
          <p dangerouslySetInnerHTML={{ __html: bodyHTML }} />
        </DivContainer>
      </div>
    </>
  );
};
